import axios from "@/axios";
import Util from "@/util/util";
import moment from "moment";

export const namespaced = true;

const defaultData = {
  id: 0,
  ratifierSignature: {
    //signatureId: 0,
    type: "TEXT",
    text: null,
    fontFamily: null,
    edit: null,
    view: null,
  },
  ratifierDateSigned: null,

};

const resetData = {
  type: "TEXT",
  text: null,
  fontFamily: null,
  edit: null,
  view: null,
};

const IMAGE_EXP = /data:image\/[a-z]+;base64,/;

export const state = {
  authorizedRatifier: Object.assign({}, defaultData),
  helper: {
    countryId: 0,
    buySell: "",
  },
  authorizeStatus: false,
  errors: [],
};

export const getters = {
  authorizedRatifier: (state) => state.authorizedRatifier,
  authorizedRatifierAuthorizeStatus: (state) => state.authorizeStatus,
  authorizedRatifierHelper: (state) => state.helper,
  authorizedRatifierErrors: (state) => state.authorizedRatifierErrors
};

export const mutations = {
  SET_RATIFIER_API: (state, response) =>{
    const ratifierSignature = (response.data && response.data.ratifierSignature)
      ? response.data.ratifierSignature
      : defaultData.ratifierSignature;

    state.authorizedRatifier = Object.assign({}, state.authorizedRatifier, response.data, { ratifierSignature });

    const decodeIfNeeded = (val) => (val && !val.match(IMAGE_EXP) ? window.atob(val) : val);

    const sig = state.authorizedRatifier.ratifierSignature || {};
    sig.edit = decodeIfNeeded(sig.edit);
    sig.view = decodeIfNeeded(sig.view);

    state.authorizedRatifier.ratifierSignature = sig;
  },
  SET_RATIFIER_SIG: (state, response) => {
    var ratifierSig = Object.assign({}, response.data.ratifierSignature ? response.data.ratifierSignature : defaultData.ratifierSignature);
    const decodeIfNeeded = (val) => (val && !val.match(IMAGE_EXP) ? window.atob(val) : val);
    ratifierSig.edit = decodeIfNeeded(ratifierSig.edit);
    ratifierSig.view = decodeIfNeeded(ratifierSig.view);
    state.authorizedRatifier.ratifierSignature = ratifierSig;
  },
  SET_RATIFIER_DATA: (state, data) => {
    state.authorizedRatifier = Object.assign({}, state.authorizedRatifier, data)
  },
  SET_AUTHORIZE_STATUS: (state, value) => (state.authorizeStatus = value),

  SET_HELPER: (state, value) => (state.helper = value),
  CLEAR_DATA: (state) => (state.authorizedRatifier = defaultData),
  SET_ERRORS: (state, data) => (state.authorizedRatifierErrors = data),
  CLEAR_ERRORS: (state) => (state.authorizedRatifierErrors = [])
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },

  async getAuthorizedRatifierAuthorizeStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_AUTHORIZE_STATUS", false);
    }
    else {
      return await axios
        .get(`/api/ratifiersignatures/authorizestatus/${id}`)
        .then(({ data }) => {
          if (data && data.length === 0) {
            commit("SET_AUTHORIZE_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
            commit("SET_AUTHORIZE_STATUS", false);
            commit("SET_ERRORS", data);
          }
        });
    }
  },

  async getAuthorizedRatifier({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_RATIFIER_API", await axios.get(`/api/ratifiersignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING RATIFIER INFORMATION: ", error); //not handelled
    }
  },
  
  async getAuthorizedRatifierSignOnly({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_RATIFIER_SIG", await axios.get(`/api/ratifiersignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING RATIFIER INFORMATION: ", error); //not handelled
    }
  },

  getCacSignature({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/signatures/certificatename")
        .then(function (response) {
          const cacSignature = "data:image/jpg;base64," + response.data;
          dispatch("setSignature", cacSignature);
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error getting the CAC signature... ${error.response.data}`);
        });
    });
  },

  setSignature({ commit, state }, signature) {
    let date = null;

    // Don't auto-set date for UPLOAD type — backend handles signature dates
    if (!Util.isNullOrEmpty(signature) && signature.type !== "UPLOAD") {
      date = Util.convertToDateTime(moment.utc().format("MM-DD-y HH:mm:ss"));
    }

    commit("SET_RATIFIER_DATA", { ratifierSignature: Object.assign({}, state.authorizedRatifier.ratifierSignature, signature), ratifierDateSigned: date });
  },
};
